var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-info-group"},[_c('v-layout',{attrs:{"justify-space-around":"","wrap":"","align-items-center":"","py-3":""}},_vm._l((_vm.timeList),function(item,index){return _c('v-flex',{key:index,attrs:{"grow":false}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(item)))]),_c('p',[_vm._v(_vm._s(_vm.data[item]))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }